import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a42bf068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slotDialog" }
const _hoisted_2 = { class: "slotDialog__outer" }
const _hoisted_3 = { class: "slotDialog__inner" }
const _hoisted_4 = {
  key: 0,
  class: "slotDialog__icon"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 3,
  class: "slotDialog__contents"
}
const _hoisted_8 = { class: "slotDialog__buttonArea" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttonClose__inner" }, "とじる", -1))

import { withDefaults, computed } from 'vue'

import AnimationPushToShadow from '@/components/AnimationPushToShadow/AnimationPushToShadow.vue'
import AppImage from '@/components/AppImage/AppImage.vue'

interface Props {
  type: 'message' | 'error' | 'confirm'
  title?: string
  messages?: string[]
  disableAgreeButton?: boolean
  size?: 'normal' | 'wide'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SlotDialog',
  props: {
    type: { default: 'message' },
    title: null,
    messages: null,
    disableAgreeButton: { type: Boolean, default: false },
    size: null
  },
  emits: ['agree', 'cancel', 'close'],
  setup(__props: any, { emit }) {

const props = __props as { type: 'message' | 'error' | 'confirm', title?: string, messages?: string[], disableAgreeButton: boolean, size?: 'normal' | 'wide' }

/**
 * SlotDialog.
 */





// 表示タイプ
const isMessage = computed(() => props.type === 'message')
const isError = computed(() => props.type === 'error')
const isConfirm = computed(() => props.type === 'confirm')

const close = () => {
  emit('close')
}

const cancel = () => {
  emit('cancel')
}

const agree = () => {
  if (props.disableAgreeButton) return
  emit('agree')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["slotDialog__wrapper", [__props.size === 'wide' ? 'slotDialog__wrapper--wide' : '']])
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(isError))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(AppImage, {
                  src: require('@/assets/image/icon/icon_warning.svg'),
                  alt: "",
                  width: "48",
                  height: "48"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          (__props.title)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "slotDialog__title",
                innerHTML: __props.title
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (__props.messages && __props.messages.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 2,
                class: _normalizeClass(["slotDialog__messages", { center: __props.messages.length === 1 }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (message, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    innerHTML: message,
                    class: _normalizeClass(["slotDialog__messages_item", { single: __props.messages.length === 1 }])
                  }, null, 10, _hoisted_6))
                }), 128))
              ], 2))
            : (_ctx.$slots.default)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "default")
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "buttonArea", {}, () => [
              (_unref(isMessage) || _unref(isError))
                ? (_openBlock(), _createBlock(AnimationPushToShadow, {
                    key: 0,
                    tag: "button",
                    backgroundColor: "#b4c3d8",
                    shadowColor: "#5b6a80",
                    shadowX: "4px",
                    shadowY: "4px",
                    rounded: "pill",
                    class: "buttonClose",
                    onClick: close
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
                : (_unref(isConfirm))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(AnimationPushToShadow, {
                        tag: "button",
                        backgroundColor: "#fdd400",
                        shadowColor: "#ff7600",
                        shadowX: "8px",
                        shadowY: "8px",
                        rounded: "pill",
                        class: "button",
                        onClick: agree
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["button__inner", { 'is-confirm-yes': _unref(isConfirm) }])
                          }, "はい", 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(AnimationPushToShadow, {
                        tag: "button",
                        backgroundColor: "#b4c3d8",
                        shadowColor: "#5b6a80",
                        shadowX: "8px",
                        shadowY: "8px",
                        rounded: "pill",
                        class: "button",
                        onClick: cancel
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["button__inner", { 'is-confirm-no': _unref(isConfirm) }])
                          }, "いいえ", 2)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}
}

})